module.exports = __webpack_public_path__ + "static/img/12.eb2a240.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/sp/12.png
// module id = zLVl
// module chunks = 0